import type { CartPatch } from '../types/cart';

export const SAGA_ACTIONS = {
  LOGIN_SUCCESS: 'checkout/LOGIN_SUCCESS',
  CHANGE_QUANTITY: 'checkout/CHANGE_QUANTITY',
  CHANGE_COUNTRY: 'checkout/CHANGE_COUNTRY',
  UPDATE_PERSISTENT_CART: 'checkout/UPDATE_PERSISTENT_CART',
  SWAP_PRODUCT: 'checkout/SWAP_PRODUCT',
  REMOVE_PRODUCT: 'checkout/REMOVE_PRODUCT',
  APPLY_PROMO_CODE: 'checkout/APPLY_PROMO_CODE',
  CHECK_EMAIL: 'checkout/CHECK_EMAIL',
  PAYPAL_INIT: 'checkout/PAYPAL_INIT',
  PAYPAL_GET_BAID: 'checkout/PAYPAL_GET_BAID',
  SUBMIT_PROOF_OF_STATUS: 'checkout/SUBMIT_PROOF_OF_STATUS',
  SET_LANGUAGE: 'app/SET_LANGUAGE',
} as const;

/** Dispatched when the sign-in popup reports success. */
export const loginSuccess = () => ({ type: SAGA_ACTIONS.LOGIN_SUCCESS });

/** `id` is the cart product's rate plan; `qty` is the new quantity. */
export const changeQuantity = (id: string, qty: number) => ({
  type: SAGA_ACTIONS.CHANGE_QUANTITY,
  id,
  qty,
});

export const changeCountry = (country: string) => ({
  type: SAGA_ACTIONS.CHANGE_COUNTRY,
  country,
});

export const updatePersistentCart = (data: CartPatch) => ({
  type: SAGA_ACTIONS.UPDATE_PERSISTENT_CART,
  data,
});

/** `ratePlan`/`quantity`: the cart product being replaced. `swapWithRatePlan`: the upgrade target's rate plan. */
export const swapProduct = (
  ratePlan: string,
  quantity: number,
  swapWithRatePlan: string,
) => ({
  type: SAGA_ACTIONS.SWAP_PRODUCT,
  ratePlan,
  quantity,
  swapWithRatePlan,
});

/** `ratePlan`: the cart product to remove. */
export const removeProduct = (ratePlan: string) => ({
  type: SAGA_ACTIONS.REMOVE_PRODUCT,
  ratePlan,
});

/** `promoCode`: the trimmed code to apply to the cart. */
export const applyPromoCode = (promoCode: string) => ({
  type: SAGA_ACTIONS.APPLY_PROMO_CODE,
  promoCode,
});

export const checkEmail = (value: string) => ({
  type: SAGA_ACTIONS.CHECK_EMAIL,
  value,
});

export const paypalInit = () => ({ type: SAGA_ACTIONS.PAYPAL_INIT });

/** `token`: the PayPal token received via the popup's `paypalData` postMessage. */
export const paypalGetBaid = (token: string) => ({
  type: SAGA_ACTIONS.PAYPAL_GET_BAID,
  token,
});

/** `language`: the code the user picked in the language switcher. */
export const setLanguage = (language: string) => ({
  type: SAGA_ACTIONS.SET_LANGUAGE,
  language,
});

export const submitProofOfStatus = () => ({
  type: SAGA_ACTIONS.SUBMIT_PROOF_OF_STATUS,
});
